import { Type } from "@sinclair/typebox";
import { buildingVolumeSchema } from "./building-volumes.js";
const position = Type.Tuple([
    Type.Number({ minimum: -180, maximum: 180 }),
    Type.Number({ minimum: -90, maximum: 90 })
]);
export const workingPortionPolygonSchema = Type.Object({
    type: Type.Literal("Polygon"),
    coordinates: Type.Array(Type.Array(position, { minItems: 4, maxItems: 1000 }), {
        minItems: 1,
        maxItems: 20
    })
}, { additionalProperties: false });
export const quoteWorkingPortionInputSchema = Type.Union([
    Type.Object({
        kind: Type.Literal("dbtr_units"),
        unitIds: Type.Array(Type.String({
            pattern: "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }), { minItems: 1, maxItems: 100, uniqueItems: true })
    }, { additionalProperties: false }),
    Type.Object({
        kind: Type.Literal("custom_polygon"),
        geometry: workingPortionPolygonSchema,
        manualHeightM: Type.Optional(Type.Number({ exclusiveMinimum: 0, maximum: 500 }))
    }, { additionalProperties: false })
]);
export const quoteWorkingPortionSnapshotSchema = Type.Object({
    input: quoteWorkingPortionInputSchema,
    geometry: Type.Exclude(buildingVolumeSchema.properties.geometry, Type.Null()),
    units: Type.Optional(Type.Array(buildingVolumeSchema, { minItems: 1, maxItems: 100 })),
    perimeterM: Type.Number({ minimum: 0 }),
    volumeM3: Type.Union([Type.Number({ minimum: 0 }), Type.Null()]),
    volumeMethod: Type.Union([
        Type.Literal("dbtr_mean_height"),
        Type.Literal("uniform_manual_height"),
        Type.Null()
    ]),
    sourceFingerprint: Type.String({ pattern: "^[a-f0-9]{64}$" })
}, { additionalProperties: false });
//# sourceMappingURL=quote-working-portion.js.map